<template>
  <div class="section-parameter" v-if="admins">
    <div class="col-left">
      <h2>Managers</h2>
    </div>
    <div class="col-right">
      <div class="manager-list form-group">
        <manager :manager="admin" v-for="(admin, index) in admins" :key="index"></manager>
        <div class="manager-to-add" @click="isFormOpened = true">
          <span><font-awesome-icon icon="plus"></font-awesome-icon></span>
        </div>
      </div>
    </div>
    <manager-form v-if="isFormOpened" @close="closeForm"></manager-form>
  </div>
</template>

<script>

import Avatar from 'vue-avatar'
import manager from '@/components/settings/settings_managers_manager.vue'
import managerForm from '@/components/settings/settings_managers_form.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Avatar, manager, managerForm
  },
  data () {
    return {
      infos: null,
      isFormOpened: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),

    ...mapGetters('account', {
      admins: 'admins'
    })
  },

  methods: {
    closeForm () {
      this.isFormOpened = false
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 24px;
}

.manager-to-add {
  border: 1px dashed #aaa;
  height: 100px;
  border-radius: 4px;
  text-align: center;
  display: grid;
  align-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #efefef;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_managers.vue